import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import Outlet from "./components/outletCard";
import LoadingCard from "./components/loading";

import FilterElement from "./../layout/FilterElement";
import Pagination from "../layout/Pagination";

import { updateFilterElement } from "../../store/actions/filterElementAction";
import { signOut } from "../../store/actions/authAction";

import "./style.css";
import "./../layout/styles/filter.css";
import Footer from "../Footer/Footer";
import outletImg from "./outlets.svg";
import { CircularProgress } from "@material-ui/core";

class Outlets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      outlets: null,
      total: null,
      limit: null,
      search_term: "",

      data_fetching: false,
      outlet_info: "",
      field_force_info: "",
    };
  }

  componentDidMount() {
    //this.set_data_set();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit
    )
      this.set_data_set();
  }

  // New function to handle search button click
  handleSearchButtonClick = (e) => {
    e.preventDefault();
    this.set_data_set();
  };

  set_data_set = () => {
    var query_param = "";
    if (this.state.outlet_info !== "")
      query_param += `&outlet_info=${this.state.outlet_info}`;
    if (this.state.field_force_info !== "")
      query_param += `&field_force_info=${this.state.field_force_info}`;

    this.setState({
      data_fetching: true,
    });

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/outlets/v1/list?page_index=${this.props.currentPage}&page_size=${this.props.currentLimit}${query_param}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return this.setState({
          outlets: res.data.data,
          total: res.data.count,
          limit: res.data.limit,

          data_fetching: false,
        });
      })
      .catch(() =>
        this.setState({
          data_fetching: false,
        })
      );
  };

  create_filter_elements = (filter, type) =>
    filter.map((item, index) => (
      <FilterElement
        key={index}
        {...item}
        selectedValue={this.props.filterElement}
        type={type}
      />
    ));

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    let current_time = Date.now().valueOf() / 1000;
    if (this.props.expiration < current_time) this.props.signOut();

    return (
      <div className="main-container">
        <div className="outlets">
          <div className="page-header" style={{ justifyContent: "center" }}>
            <div className="page-heading-search">
              {true && (
                <div className="page-heading">
                  Outlets
                  <div className="page-sub-heading">
                    {this.state.total} Outlets in Dexter Database
                  </div>
                </div>
              )}
              <form className="outlet-search-container">
                <input
                  type="text"
                  className="search_outlet"
                  placeholder="Search by Wallet Number "
                  onChange={(e) =>
                    this.setState({
                      outlet_info: e.target.value,
                    })
                  }
                />
                <input
                  type="text"
                  className="search_outlet"
                  placeholder="Search by Field Force "
                  onChange={(e) =>
                    this.setState({
                      field_force_info: e.target.value,
                    })
                  }
                />
                <button
                  onClick={this.handleSearchButtonClick}
                  className="search-button"
                  type="submit"
                >
                  {this.state.data_fetching ? (
                    <CircularProgress size={14} color="white" />
                  ) : (
                    "Search"
                  )}
                </button>
              </form>
            </div>
            <div className="page-settings"></div>
          </div>

          <Pagination
            page={"outlets"}
            currentPage={this.props.currentPage}
            total={this.state.total}
            limit={this.props.currentLimit}
          />

          {this.state.data_fetching ? (
            <LoadingCard />
          ) : this.state.outlets ? (
            <div className="card-row row">
              {this.state.outlets.map((item, index) => (
                <div key={index} className="card-col col l4 m12 s12">
                  <Outlet outlet={item} index={index} />
                </div>
              ))}
            </div>
          ) : (
            <div className="placeholder-image-container">
              <img src={outletImg} alt="No outlets available" />
            </div>
          )}

          <Pagination
            page={"outlets"}
            currentPage={this.props.currentPage}
            total={this.state.total}
            limit={this.props.currentLimit}
          />
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let currentPage = state.page.outlets
    ? state.page.outlets.currentPage
    : state.page.default.currentPage;

  let currentLimit = state.paginationLimit.outlets
    ? state.paginationLimit.outlets.currentLimit
    : 12;

  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let portal = state.auth.authToken ? state.auth.authToken.portal : "dexter";

  return { currentPage, currentLimit, expiration, portal };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateFilterElement: (filter) => dispatch(updateFilterElement(filter)),
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Outlets);
